<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap">
      <button class="btn btn-success btn-sm" v-b-tooltip.hover :title="$t('announcement_schedule.add_sched_btn')" v-on:click="addEntry(null)"><b-icon icon="plus" font-scale="1.5"></b-icon></button>
      <button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('announcement_schedule.del_sched_btn')" v-on:click="removeEntry"><b-icon icon="dash" font-scale="1.5"></b-icon></button>
    </div>

    <template v-for="(item, index ) in schedEntries">
        <b-card no-body class="mb-1" v-bind:key="idGenerator(item, index)">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle='"accordion-"+index' variant="info">{{$t('announcement_schedule.rule_title')}} #{{index}}</b-button>
          </b-card-header>
          <b-collapse v-bind:class="{visible: index == 0}" v-bind:id='"accordion-"+index' visible accordion="hanuri" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <AnnouncementScheduleEntry v-bind:key="idGenerator(item, index)" v-bind:id="idGenerator(item, index)" :ref='"entry"+index' v-bind:args="item">
                </AnnouncementScheduleEntry>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </template>
  </div>
</template>

<script>
import AnnouncementScheduleEntry from '@/components/Announcements/AnnouncementScheduleEntry'
let nextTempId = -1;
export default {
  name: 'AnnouncementScheduleEditor',
  props: {
    scheduleList: Array,
    creatingNew: Boolean
  },
  components: {
    AnnouncementScheduleEntry
  },
  data() {
      return {
        announcementType:null
        ,schedEntries: []
        ,entryRefs: []
        ,entryCount: 0
      }
  },
  beforeCreate: function() {
  },
  created: function() {
    var list = this.scheduleList;
    this.schedEntries = [];
    for(var i = 0;i < list.length; i++) {
      this.addEntry(list[i]);
    }
  },
  watch: {
    scheduleList: function() {
        var list = this.scheduleList;
        this.schedEntries = [];
        for(var i = 0;i < list.length; i++) {
          this.addEntry(list[i]);
        }
    },
    creatingNew: function() {
      if(this.creatingNew) {
        this.createNewSchedulePlan();
      }
    },
  },
  methods:{
    createNewSchedulePlan: function() {
      this.schedEntries = [];
      this.addEntry(null);
    },
    addEntry : function(entryData) {
      if(entryData == null) {
        entryData = {id: this.generateTempId()};
        this.collectScheduleData();
      }
      this.entryCount++;
      this.schedEntries.push(entryData);
    },
    removeEntry: function() {
      if(this.entryCount > 0) {
        this.schedEntries.pop();
        this.entryCount--;
      }
    },
    resetForm : function() {
    },
    collectScheduleData:  function () {
      var allEntries = [];
      for (var i = 0; i < this.schedEntries.length; i++) {
        var entryKey = "entry" + i;
        var ent = this.$refs[entryKey];
        if (ent && ent[0]) {
          var entry = ent[0].getEntry();
          if (entry.tempId) {
            delete entry.tempId;
          }
          if (entry.id === null || entry.id < 0) {
            delete entry.id;
          }
          allEntries.push(entry);
        }
      }
      return allEntries;
    },
    generateTempId() {
      return nextTempId--;
    },
    idGenerator(item) {
      if (item.id == null || item.id === -1) {
        if (!item.tempId) {
          item.tempId = this.generateTempId();
        }
        return "ID" + item.tempId;
      }
      return "ID" + item.id;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
